<template>
    <BaseSection
        v-if="boardMembers && boardMembers?.length"
        class="section--wide"
    >
        <template #title>
            <h2>Board</h2>
        </template>
        <BaseMemberList
            :members="boardMembers"
            :show-conflict-of-interest="true"
        />
    </BaseSection>
</template>

<script setup>
defineProps({
    boardMembers: {
        type: Array,
        required: true
    }
});
</script>
